import urlParse from 'url-parse';

import type { Filters } from '@skyscanner-internal/global-components/hotels-search-controls/common/types/filters';
import type { Destination } from '@skyscanner-internal/global-components/hotels-search-controls/common/types/suggestion';

export type DayViewURLProps = {
  destination: Destination;
  filter?: Filters;
  rooms?: number;
  adults?: number;
  childrenAges?: string[];
  checkInDate?: string;
  checkOutDate?: string;
  source?: string;
  copyPastePartnerId?: string;
};

export type SearchParamsURLProps = {
  destination?: { entityId?: string };
  filter?: Filters;
  rooms?: number;
  adults?: number;
  childrenAges?: string[];
  checkInDate?: string;
  checkOutDate?: string;
  url: string;
  source?: string;
  copyPastePartnerId?: string;
};

export const getUpdatedSearchParamsUrl = ({
  adults,
  checkInDate,
  checkOutDate,
  childrenAges,
  copyPastePartnerId,
  destination,
  filter,
  rooms,
  source,
  url,
}: SearchParamsURLProps): string => {
  const { entityId } = destination || {};
  const urlObj = urlParse(url, true);
  const { query } = urlObj;
  const childrenAgesString = childrenAges && childrenAges.join(',');

  if (entityId) {
    query.entity_id = entityId;
  }
  if (checkInDate) {
    query.checkin = checkInDate;
  }
  if (checkOutDate) {
    query.checkout = checkOutDate;
  }
  if (adults) {
    query.adults = adults;
  }
  if (rooms) {
    query.rooms = rooms;
  }
  if (childrenAgesString) {
    query.children_ages = childrenAgesString;
  } else {
    delete query.children_ages;
  }
  if (filter && Object.keys(filter).length) {
    query.filters = JSON.stringify(filter);
  } else {
    delete query.filters;
  }
  if (source) {
    query.source = source;
  } else {
    delete query.source;
  }
  if (copyPastePartnerId) {
    query.copy_paste_partner_id = copyPastePartnerId;
  } else {
    delete query.copy_paste_partner_id;
  }

  urlObj.set('query', query);
  return urlObj.toString();
};

const getDayviewUrl = ({
  adults,
  checkInDate,
  checkOutDate,
  childrenAges,
  copyPastePartnerId,
  destination,
  filter,
  rooms,
  source,
}: DayViewURLProps): string => {
  const baseUrl = `/hotels/search`;
  return getUpdatedSearchParamsUrl({
    url: baseUrl,
    destination,
    filter,
    rooms,
    adults,
    childrenAges,
    checkInDate,
    checkOutDate,
    source,
    copyPastePartnerId,
  });
};

export default getDayviewUrl;
